import script from "./Carrossel.vue?vue&type=script&setup=true&lang=js"
export * from "./Carrossel.vue?vue&type=script&setup=true&lang=js"

import "./Carrossel.vue?vue&type=style&index=0&id=6a92ed4e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a92ed4e"]])

export default __exports__